export default {"src":"/_next/static/media/crossBlack.b2a422d9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};